(function ($) {

    $(document).on('submit', 'form.ajax', function(event) {
        event.preventDefault();
        let form = $(this);
        let formData = new FormData(form[0]);

        $.ajax({
            url: ajax.ajaxurl,
            type: 'POST',
            data: formData,
            cache: false,
            contentType: false,
            processData: false,
            success: function(data) {
                form.trigger('ajaxSuccess', data);
            },
            error: function(data) {
                form.trigger('ajaxError', data);
            },
            done: function(data) {
                form.trigger('ajaxDone', data);
            }
        });
    });

    $(document).on('ajaxSuccess', 'form.ajax', function(event, data) {
        let form = $(this);
        if(form.hasClass('js-noclient-form')) {
            dataLayer.push({
                event: 'kapcsolatfelvetel',
            });
        }
        if(form.hasClass('js-client-form')) {
            dataLayer.push({
                event: 'ugyfel_kapcsolatfelvetel',              
            });
        }
        form.find('.invalid-feedback').html('').addClass('d-none');
        form.find('.has-error').removeClass('has-error');
        form.find('input, select, textarea').removeClass('is-invalid');
        if (typeof data.alertMessage !== 'undefined' && data.alertMessage !== null) {
            Swal.fire({
                text: data.alertMessage,
                icon: 'success',
                confirmButtonText: 'Bezár'
            })
        }
    });

    $(document).on('ajaxError', 'form.ajax', function(event, data) {
        if (typeof data.responseJSON.result !== 'undefined' &&
            typeof data.responseJSON.title !== 'undefined' &&
            data.responseJSON.result === 'recaptcha_error'
        ) {
            Swal.fire({
                text: data.responseJSON.title,
                icon: 'error',
                confirmButtonText: 'Bezár'
            })

            return;
        }

        let form = $(this);

        form.find('.invalid-feedback').html('').addClass('d-none').removeClass('d-block');
        form.find('.has-error').removeClass('has-error');
        form.find('input, select, textarea').removeClass('is-invalid');

        $.each(data.responseJSON.errors, function (index, value) {
            let elements = index.split('.');

            let container = form.find('[name="' + elements[0] + '[' + elements[1] + ']"]').closest('.custom-control');


            if (container.length < 1) {
                container = form.find('[name^="' + elements[0] + '["]').closest('.form-group');
            }

            if (container.length < 1) {
                container = form.find('[name="' + index + '"]').closest('.form-group');
            }

            container.addClass('has-error');
            container.find('input, select, textarea').addClass('is-invalid');
            container.find('.invalid-feedback').html(value).removeClass('d-none').addClass('d-block');

        });

        $(form.find('.has-error')[0]).find('input').focus();

        $(form.find('.has-error')[0]).find('textarea').focus();
       
        if($(form.find('.has-error')[0]).hasClass('js-custom-file-input-wrapper')) {
            $(form.find('.has-error')[0]).find('label').focus();
        }

        if($(form.find('.has-error')[0]).hasClass('js-custom-select-wrapper')) {
            $(form.find('.has-error')[0]).find('label').focus();
        }

        if (typeof data.responseJSON.alertMessage !== 'undefined' && data.responseJSON.alertMessage !== null) {
            Swal.fire({
                text: data.responseJSON.alertMessage,
                icon: 'error',
                confirmButtonText: 'Bezár'
            })
        }
    });

    $(document).on('change', 'form.ajax .is-invalid', function() {
        let container = $(this).closest('.has-error');

        if (container.length > 0) {
            container.find('.is-invalid').removeClass('is-invalid');
            container.removeClass('has-error');
            container.find('.invalid-feedback').addClass('d-none').removeClass('d-block');
        }
    });

    $(document).on('keyup', 'form.ajax input.is-invalid, form.ajax textarea.is-invalid', function() {
        $(this).change();
    });

})(jQuery);


